<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M14 24a4 4 0 11-8 0 4 4 0 018 0zm28 0a4 4 0 11-8 0 4 4 0 018 0zm-18 4a4 4 0 100-8 4 4 0 000 8z"/></svg>